const initialState = {
    invoiceAdd: [],
    isAddingInvoice: false,
    isFetchingInvoice: false,
    invoiceList: [],
};

const InvoiceReducer = (state = initialState, action) => {
    switch (action.type) {
        case "REQUEST_ADD_INVOICE":
            return { ...state, isAddingInvoice: true };
        case "SUCCESS_ADD_INVOICE":
            return { ...state, invoiceAdd: action.payload, isAddingInvoice: false };
        case "ERROR_ADD_INVOICE":
            return { ...state, isAddingInvoice: true };


        case "REQUEST_GET_INVOICE":
            return { ...state, isFetchingInvoice: true };
        case "SUCCESS_GET_INVOICE":
            return { ...state, invoiceList: action.payload, isFetchingInvoice: false };
        case "ERROR_GET_INVOICE":
            return { ...state, isFetchingInvoice: false };


        default:
            return state;
    }
};
export default InvoiceReducer;